import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Phone = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M10 19h4m-6 3h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.25 4A2.75 2.75 0 0 1 8 1.25h8A2.75 2.75 0 0 1 18.75 4v16A2.75 2.75 0 0 1 16 22.75H8A2.75 2.75 0 0 1 5.25 20zm4 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
